import {
  REDEEM_QR_REQUEST,
  REDEEM_QR_SUCCESS,
  REDEEM_QR_FAIL,
} from "../actionTypes";
import {
  QR_STATUS_REQUEST,
  QR_STATUS_SUCCESS,
  QR_STATUS_FAIL,
   FETCH_OTP_REQUEST,
  FETCH_OTP_SUCCESS,
  FETCH_OTP_FAIL,
    FETCH_CUSTOMER_DETAILS_REQUEST,
  FETCH_CUSTOMER_DETAILS_SUCCESS,
  FETCH_CUSTOMER_DETAILS_FAIL,
    REDEEM_PROMOTIONAL_QR_REQUEST,
  REDEEM_PROMOTIONAL_QR_SUCCESS,
  REDEEM_PROMOTIONAL_QR_FAIL
} from "../actionTypes";
const initialState = {
  otpMessage: "",
  loading: false,
  success: false,
  error: null,
   statusInfo: null,
};

const promotionalRedeemInitialState = {
  loading: false,
  success: false,
  redeemData: null,
  error: null,
};

export const consumerReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDEEM_QR_REQUEST:
       return { ...state, loading: true, success: false, error: null };
  case REDEEM_QR_SUCCESS:
  return { ...state, loading: false, success: true, redeemData: action.payload };
  //   case REDEEM_QR_FAIL:
  //     // return { ...state, loading: false, error: action.payload };
  //     return { ...state, loading: false, success: false,error: action.payload?.message || action.payload,  
  //   redeemData: action.payload 
  // };
    
//   case REDEEM_QR_FAIL: {
//   const transferMsg = action.payload?.cashfree_status?.transfer_payment?.message || "";
//   const descMatch = transferMsg.match(/'statusDescription':\s*'([^']+)'/);
//   const friendlyError = descMatch
//     ? descMatch[1]                              // ← clean UPI failure reason
//     : action.payload?.message || "Something went wrong";

//   return {
//     ...state,
//     loading: false,
//     success: false,
//     error: friendlyError,    // ← always a plain string now
//     redeemData: action.payload,
//   };
// }
case REDEEM_QR_FAIL: {
  const payload = action.payload;
  const transferPayment = payload?.cashfree_status?.transfer_payment;
  const addBeneficiary = payload?.cashfree_status?.add_beneficiary;

  // Check add_beneficiary failure first
  const beneficiaryFailed = addBeneficiary?.status === "FAILED" || addBeneficiary?.status === "ERROR";
  const transferFailed = transferPayment?.status === "FAILED" || transferPayment?.status === "ERROR";

  let friendlyError = null;

  if (beneficiaryFailed) {
    // Extract statusDescription or message from add_beneficiary
    const rawMsg = addBeneficiary?.message || "";
    const descMatch = rawMsg.match(/'message':\s*'([^']+)'/) || rawMsg.match(/'statusDescription':\s*'([^']+)'/);
    friendlyError = descMatch ? descMatch[1] : "Please provide a valid UPI ID.";

  } else if (transferFailed) {
    const rawMsg = transferPayment?.message || "";
    const descMatch = rawMsg.match(/'statusDescription':\s*'([^']+)'/);
    friendlyError = descMatch ? descMatch[1] : "UPI transfer failed. Please check your UPI ID.";

  } else {
    friendlyError = payload?.message || "Something went wrong";
  }

  return {
    ...state,
    loading: false,
    success: false,
    error: friendlyError,
    redeemData: payload,
  };
}
  default:
      return state;
  }
};
export const qrStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case QR_STATUS_REQUEST:
      return { ...state, loading: true, error: null };
    case QR_STATUS_SUCCESS:
      return { ...state, loading: false, statusInfo: action.payload };
    case QR_STATUS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
export const otpReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OTP_REQUEST:
      return {
        ...state,
        loading: true,
        otpError: null,
        otpMessage: "",
      };

    case FETCH_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        otpSent: true,
        otpMessage: action.payload.message || "OTP sent successfully",
        otpError: null,
      };

    case FETCH_OTP_FAIL:
      return {
        ...state,
        loading: false,
        otpSent: false,
        otpError: action.payload,
        otpMessage: "",
      };

    default:
      return state;
  }
};
export const customerDetailsReducer = (state = customerDetailsInitialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_DETAILS_REQUEST:
      return { ...state, loading: true, error: null, customerData: null };
    case FETCH_CUSTOMER_DETAILS_SUCCESS:
      return { ...state, loading: false, customerData: action.payload };
    case FETCH_CUSTOMER_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
export const promotionalRedeemReducer = (state = promotionalRedeemInitialState, action) => {
  switch (action.type) {
    case REDEEM_PROMOTIONAL_QR_REQUEST:
      return { ...state, loading: true, success: false, error: null };
    case REDEEM_PROMOTIONAL_QR_SUCCESS:
      return { ...state, loading: false, success: true, redeemData: action.payload };
    case REDEEM_PROMOTIONAL_QR_FAIL:
      return { ...state, loading: false, success: false, error: action.payload, redeemData: action.payload };
    default:
      return state;
  }
};
export default consumerReducer;
